<app-organization-sd
  [agency]="agencyService.agency"
>
</app-organization-sd>

<div
  fxHide
  fxShow.gt-sm
  class="home-imgmap"
>
  <app-map-plan-project-base
    [agency]="agencyService.agency"
    [projects]="projects"
  >
  </app-map-plan-project-base>
</div>

<section
  fxShow
  fxHide.gt-sm
  class="container-fluid hero"
>
  <div>
    <h1>
      A fost odată ca niciodată un vis, în 2012, care astăzi găzduiește locatari în 935 apartamente!
    </h1>
    <h2>
      Dream Residence e mai mult decât un cartier, e o comunitate!
    </h2>

    <label>
      Selectează blocul:
    </label>
    <app-map-plan-project-mobile-base [projects]="projects">
    </app-map-plan-project-mobile-base>

    <p>
      Proiectul Dream Residence a luat naștere în urma dorinței de a transforma locuința ideală mult visată în realitate.
      De aceea, pentru noi a fost foarte important să alegem o locație potrivită în care să punem bazele nu numai unui nou cartier, ci a unei noi comunități care întrunește aceleași principii și valori.
    </p>
  </div>
</section>

<section class="container-fluid info">
  <div
    fxLayout="column"
    fxLayout.gt-sm="row"
    fxLayoutAlign="space-between center"
  >
    <div
      fxHide
      fxShow.gt-sm
    >
      A fost odată ca niciodată un vis, în 2012, care astăzi găzduiește locatari în 935 apartamente! Dream Residence e mai mult decât un cartier, e o comunitate!
    </div>
    <a
      target="_blank"
      mat-raised-button
      color="main-color"
      href="/assets/brosura.pdf"
    >
      Răsfoiește broșura
    </a>
  </div>

</section>

<section
  fxLayout="column"
  fxLayout.gt-md="row"
  fxLayoutAlign="center center"
  class="about-us"
>
  <div
    fxHide
    fxShow.gt-md
    fxLayout="row"
    fxLayoutAlign="center center"
    class="about-us-left"
    >
    <div
      fxHide
      fxShow.gt-sm
      fxLayout="column"
      fxLayoutAlign="center center"
      class="images-container"
    >
      <div
        class="img-wrapper"
        (click)="open(0)"
      >
        <div
          style="background-image: url('/assets/images/home/about_us_1.webp')"
        >
        </div>
      </div>
      <div
        class="img-wrapper"
        (click)="open(1)"
      >
        <div
          style="background-image: url('/assets/images/home/about_us_2.webp')"
        >
        </div>
      </div>
    </div>
    <div
      class="img-wrapper img-wrapper-full"
      (click)="open(2)"
    >
      <div
        style="background-image: url('/assets/images/home/about_us_3.webp')"
        class="image-left"
      >
      </div>
    </div>
  </div>
  <div
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayoutAlign.gt-md="start start"
    class="about-us-right"
  >
    <h2 class="about-us-right-title">
      Despre {{ agencyService.agency.name }}
    </h2>
    <p class="about-us-right-content">
      Dream Residence, complex rezidential în Rahova (sector 5, zona Sebastian, Pucheni), este investiția de lungă durată în tine, familia ta și calitatea vieții tale. De aceea, îți punem la dispoziție un complex rezidențial inclus într-o ofertă accesibilă, cu toate elementele necesare pentru a îndeplini criteriile casei tale mult visate. În cadrul proiectului, vei găsi un mix de garsoniere, apartamente 2 camere și 3 camere de vânzare, atent compartimentate, ce țin cont de cerințele tale, dar în același timp ieftine.
    </p>
    <a
      mat-raised-button
      color="main-color"
      routerLink="despre-noi"
    >
      vezi mai multe
    </a>
  </div>
</section>

<section
  fxLayout="column"
  fxLayoutAlign="center center"
  class="why-us"
>
  <h2 class="why-us-title">
    De ce {{ agencyService.agency.name }}?
  </h2>
  <div
    class="why-us-list"
    fxLayout="row wrap"
    fxLayoutAlign="center stretch"
    fxLayoutAlign.gt-xs="space-around center"
  >
    <div
      *ngFor="let reason of reasons"
      fxLayout="column"
      fxLayoutAlign="start center"
      class="why-us-item"
    >
      <div
        fxLayout="column"
        fxLayoutAlign="start center"
        class="wu-item-title"
      >
        <img [src]="reason.image.url" alt="" class="icon" loading="lazy">
        <h4>
          {{ reason.name }}
        </h4>
        <p>
          {{ reason.description }}
        </p>
      </div>
    </div>
  </div>
  <div
    fxLayout="row"
    fxLayoutAlign="center center"
    class="button-wrapper"
  >
    <a
      mat-raised-button
      color="secondary"
      routerLink="despre-noi/facilitati"
      class="why-us-button"
    >
      vezi mai multe
    </a>
  </div>
</section>

<section class="bottom-section">
  <app-testimonials-carousel></app-testimonials-carousel>
</section>



// WEBPACK FOOTER //
// ./src/app/home/home.component.html